<template>
	<section class="Stats mb-5">
		<!-- <div class="wrapper"> -->
		<div
			v-show="showTotalRev"
			class="d-flex align-start gap-20 flex-wrap flex-lg-nowrap"
		>
			<v-card v-show="showTotalRev" class="flex-grow-1">
				<div class="statsGroup d-flex">
					<StatChip
						class="h-center-value"
						:format="statFormats.CURRENCY"
						:value="totalRevenueTentative"
						label="Total Tentative Revenue"
					/>
				</div>
			</v-card>
			<v-card v-show="showTotalRev" class="flex-grow-1">
				<div class="statsGroup d-flex">
					<StatChip
						class="h-center-value"
						:format="statFormats.CURRENCY"
						:value="banquetRevenue"
						label="Definite F&B Revenue"
						chain="+"
					/>
					<StatChip
						class="h-center-value"
						:format="statFormats.CURRENCY"
						:value="roomsRevenue"
						label="Definite Rooms Revenue"
						chain="="
					/>
					<StatChip
						class="strong h-center-value"
						:format="statFormats.CURRENCY"
						:value="totalRevenueDefinite"
						label="Total Definite Revenue"
					/>
				</div>
			</v-card>
			<!-- <v-card v-show="showFeesInv" class="flex-grow-1">
				<div class="statsGroup d-flex">
					<StatChip
						:format="statFormats.CURRENCY"
						:value="totalInvestment"
						label="Venuelocity Fees"
					/>
					<StatChip
						:format="statFormats.CURRENCY"
						:value="investMinusComm"
						label="Total Investment"
					/>
				</div>
			</v-card> -->
			<!-- <v-card v-show="showFeesInv" class="flex-grow-1">
				<div class="statsGroup d-flex">
					<StatChip
						:value="roi"
						label="Return on Investment"
						color
						strong
					/>
				</div>
			</v-card> -->
		</div>

		<div
			class="d-flex align-start gap-20 mt-5 flex-wrap flex-lg-nowrap"
		>
			<v-card class="flex-grow-1">
				<a class="statsGroup d-flex"
					@click="handleSeachValue('')"
				>
					<StatChip
						class="strong color h-center-value"
						:value="leads.length"
						label="Inbound leads"
					/>
					<!-- <StatChip
						:value="definiteLeads.length"
						label="Total Deals - Definite"
					/>
					<StatChip
						:format="statFormats.PERCENT"
						:value="closeRate"
						label="Close Rate"
						color
						strong
					/> -->
				</a>
			</v-card>
			
			<v-card class="flex-grow-1" :class="isActiveStat == 'New' ? 'active' : null">
				<a class="statsGroup d-flex"
					@click="handleSeachValue('New')"
				>
					<StatChip
						class="color h-center-value"
						:value="totalNewLeads.length"
						label="New Leads"
					/>
				</a>
			</v-card>

			<v-card class="flex-grow-1" :class="isActiveStat == 'Prospect' ? 'active' : null">
				<a class="statsGroup d-flex"
					@click="handleSeachValue('Prospect')"
				>
					<StatChip
						class="color h-center-value"
						:value="totalProspectLeads.length"
						label="Prospect Leads"
					/>
				</a>
			</v-card>

			<v-card class="flex-grow-1" :class="isActiveStat == 'Tentative' ? 'active' : null">
				<a class="statsGroup d-flex"
					@click="handleSeachValue('Tentative')"
				>
					<StatChip
						class="color h-center-value"
						:value="totalTentativeLeads.length"
						label="Tentative Leads"
					/>
				</a>
			</v-card>

			<v-card class="flex-grow-1" :class="isActiveStat == 'Definite' ? 'active' : null">
				<a class="statsGroup d-flex"
					@click="handleSeachValue('Definite')"
				>
					<StatChip
						class="color h-center-value"
						:value="totalDefiniteLeads.length"
						label="Definite Leads"
					/>
					<!-- <StatChip
						:value="definiteLeads.length"
						label="Total Deals - Definite"
					/> -->
				</a>
			</v-card>
		</div>

		<div
			v-if="expandedStats"
			class="d-flex gap-20 mt-5 flex-wrap flex-lg-nowrap"
		>
			<v-card class="statsChart">
				<span class="statsChart_label"
					>Total Leads- 12 Month Trailing</span
				>
				<LineChart
					class="Chart"
					:datasetsList="linechartDatasets"
					:labelsList="linechartLabels"
					v-if="linechartDatasets.length > 0"
				/>
			</v-card>
			<v-card class="statsChart">
				<span class="statsChart_label"
					>Total Revenue - 12 Month Trailing</span
				>
				<BarChart
					class="Chart"
					:datasetsList="barchartDatasets"
					:labelsList="barchartLabels"
				/>
			</v-card>
		</div>

		<div class="d-flex justify-center mt-3">
			<button
				class="stats_toggle"
				@click="() => setExpandedStats(!expandedStats)"
			>
				<span v-if="!expandedStats"> + View More </span>
				<span v-if="expandedStats"> - View Less </span>
			</button>
		</div>
		<!-- </div> -->
	</section>
</template>

<script>
import StatChip from "@/components/StatChip";
import LineChart from "@/components/LineChart";
import BarChart from "@/components/BarChart";
import { EventBus, objectSortedByKeys } from "@/utilities";
import {
	STAT_FORMATS,
	LEAD_STATUSES,
	LINECHART_COLORS,
	BARCHART_COLORS,
	BUS_EVENTS,
} from "@/constants";

import { mapGetters, mapActions } from "vuex";

export default {
	name: "StatsSocial",
	props: {
		dates: {
			type: Array,
			default() {
				return [];
			},
		},
		lead_id: {
			type: Number | String,
			default: null,
		},
	},
	data() {
		return {
			tentativeRevenue: 0,
			definiteRevenue: 0,
			investment: 0,
			tentativeLeads: [],
			definiteLeads: [],
			linechartLabels: [],
			linechartDatasets: [],
			barchartLabels: [],
			barchartDatasets: [],
			statFormats: STAT_FORMATS,
			expandedStats: false,
		};
	},
	computed: {
		...mapGetters({
			leads: "StateLeads",
			totalInvestment: "StateTotalInvestment",
			showTotalRev: "StateShowTotalRev",
			showFeesInv: "StateShowFeesInv",
		}),

		investMinusComm() {
			const num = this.totalInvestment;
			if (num <= 0) return 0;
			return num;
		},

		roi() {
			if (this.definiteRevenue < 1 || this.investMinusComm < 1)
				return `N/A`;
			return `${parseInt(this.definiteRevenue / this.investMinusComm)}:1`;
		},
		closeRate() {
			return (this.definiteLeads.length / this.leads.length) * 100;
		},
		roomsRevenue() {
			return this.definiteLeads
				.map((lead) => lead.rooms)
				.reduce((total, rev) => Number(total) + Number(rev), 0);
		},
		banquetRevenue() {
			return this.definiteLeads
				.map((lead) => lead.banquet)
				.reduce((total, rev) => Number(total) + Number(rev), 0);
		},
		totalRevenue() {
			return this.banquetRevenue + this.roomsRevenue;
		},
		totalRevenueDefinite() {
			this.definiteLeads = this.leads.filter(
				(lead) => lead.status === LEAD_STATUSES.DEFINITE
			);
			return (this.definiteRevenue = this.calcRevenues(
				this.definiteLeads
			));
		},
		totalRevenueTentative() {
			this.tentativeLeads = this.leads.filter(
				(lead) => lead.status === LEAD_STATUSES.TENTATIVE
			);
			return (this.tentativeRevenue = this.calcRevenues(
				this.tentativeLeads
			));
		},
		totalNewLeads() {
			return (this.tentativeLeads = this.leads.filter(
				(lead) => lead.status === LEAD_STATUSES.NEW
			));
		},
		totalProspectLeads() {
			return (this.tentativeLeads = this.leads.filter(
				(lead) => lead.status === LEAD_STATUSES.PROSPECT
			));
		},
		totalTentativeLeads() {
			return (this.tentativeLeads = this.leads.filter(
				(lead) => lead.status === LEAD_STATUSES.TENTATIVE
			));
		},
		totalDefiniteLeads() {
			return (this.tentativeLeads = this.leads.filter(
				(lead) => lead.status === LEAD_STATUSES.DEFINITE
			));
		},
		isActiveStat: {
			get(){
				return this.$store.state.leads.searchValue;
			}
		}
	},
	methods: {
		...mapActions(["getLeads", "getDataCharts"]),

		calcRevenues(leads = []) {
			const revenues = (leads = []) =>
				leads.map((lead) => Number(lead.rooms) + Number(lead.banquet));
			const totalRevenue = (revenues = []) =>
				revenues.reduce((total, rev) => Number(total) + Number(rev), 0);

			return totalRevenue(revenues(leads));
		},
		setExpandedStats(expanded = false) {
			this.expandedStats = expanded;
		},
		async renderCharts() {
			const dataCharts = await this.getDataCharts();

			if (dataCharts.msg !== "Success") {
				console.error("renderCharts Error", dataCharts.msg);
			} else {
				// LINE-CHART
				const linechartLabels =
					dataCharts.charts.allLeadsVsDefinite.datesLabel;
				const sortedLinechartLabels = Object.keys(linechartLabels)
					.sort()
					.map((label) => linechartLabels[label]);
				this.linechartLabels = sortedLinechartLabels;

				const linechartData = dataCharts.charts.allLeadsVsDefinite.data;
				this.linechartDatasets = Object.keys(linechartData)
					.filter((status) => status !== "Tentative")
					.map((status) => {
						const backgroundColor = LINECHART_COLORS.find(
							(color) => color.name === status
						)
							? LINECHART_COLORS.find(
									(color) => color.name === status
							  ).bg
							: "rgba(0,0,255,0.1)";
						const label = LINECHART_COLORS.find(
							(color) => color.name === status
						)
							? LINECHART_COLORS.find(
									(color) => color.name === status
							  ).label
							: "Others";
						// const borderColor = LINECHART_COLORS.find(color => color.name === status) ? LINECHART_COLORS.find(color => color.name === status).border : 'blue';

						return {
							data: [
								...Object.values(
									objectSortedByKeys(linechartData[status])
								),
							],
							label,
							backgroundColor,
							borderWidth: 0,
							lineTension: 0,
							// borderColor,
						};
					});

				// BAR-CHART
				const barchartLabels = dataCharts.charts.roi.datesLabel;
				const sortedBarchartLabels = Object.keys(barchartLabels)
					.sort()
					.map((label) => barchartLabels[label]);
				this.barchartLabels = sortedBarchartLabels;

				const barchartData = dataCharts.charts.roi.data;
				this.barchartDatasets = Object.keys(barchartData).map(
					(status) => {
						const backgroundColor = BARCHART_COLORS.find(
							(color) => color.name === status
						)
							? BARCHART_COLORS.find(
									(color) => color.name === status
							  ).bg
							: "rgba(0,0,255,0.1)";
						const label = BARCHART_COLORS.find(
							(color) => color.name === status
						)
							? BARCHART_COLORS.find(
									(color) => color.name === status
							  ).label
							: "Others";
						// const borderColor = BARCHART_COLORS.find(color => color.name === status) ? BARCHART_COLORS.find(color => color.name === status).border : 'blue';

						return {
							data: [
								...Object.values(
									objectSortedByKeys(barchartData[status])
								),
							],
							label,
							backgroundColor,
							borderWidth: 0,
							// borderColor,
						};
					}
				);
			}
		},
		async updateStats() {
			const showDashboard = await this.getLeads({
				dates: this.dates,
				lead_id: this.lead_id,
			});
			if (!showDashboard) {
				this.$router.push("/select-property");
			}
			this.renderCharts();
		},
		handleSeachValue ( StatChipValue ){
			this.$store.commit('setNewSearch', StatChipValue);
		}
	},
	beforeMount() {
		this.updateStats();
		EventBus.$on(BUS_EVENTS.STATS_UPDATED, this.updateStats);
	},
	components: { StatChip, LineChart, BarChart },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/colors.scss";
/deep/ .v-card {
	transition: all .3s ease;
}
/deep/ .v-card.active {
	border: 1px solid $purple !important;
}
</style>


// WEBPACK FOOTER //
// src/components/StatsSocial.vue